export class BasicPromptTemplate {
    private template = '';


    constructor(name: string) {
        this.template += `# ${name}\n\n`;
    }

    public addTemplateSection(name: string, content: string): void {
        this.template += `## ${name}\n\n${content}\n\n`;
    }

    public getTemplate(): string {
        return this.template;
    }
}
